import fetch from '@/utils/fetch'

// 获取预警商品列表
export const listsUrl = '/secure/spu_order/spu_warning/lists'
// 日志列表
export const logsUrl = '/secure/spu_order/spu_warning_log/lists'

// 获取基础配置
export function getSecureSpuOrderSetting(query) {
  return fetch({
    url: '/secure/spu_order/setting/get',
    method: 'get',
    data: query
  })
}

// 设置基础配置
export function setSecureSpuOrderSetting(data) {
  return fetch({
    url: '/secure/spu_order/setting/set',
    method: 'post',
    data
  })
}

// 修改预警商品订单拦截状态
export function setSecureSpuOrderOpenStatus(data) {
  return fetch({
    url: '/secure/spu_order/spu_warning/open_status',
    method: 'post',
    data
  })
}

// 导出预警记录明细
export function secureSpuOderSpuWarningLists(data) {
  return fetch({
    url: listsUrl,
    method: 'get',
    params: data
  })
}

